import { Box, Card, Chip, Dialog, Stack } from '@mui/material';
import { ReactElement, useState } from 'react';
import {
  CreateButton,
  Datagrid,
  EditButton,
  Filter,
  FunctionField,
  List,
  TextField,
  useTranslate,
  SelectInput,
} from 'react-admin';
import { CustomBreadcrumbs } from '../../../../components/custom-breadcrumbs';
import { DashboardContent } from '../../../../layouts/dashboard';
import { Resources } from '../resource';
import { PermissionGuard } from 'src/routes/components/permission-guard';
import ErrorPage403 from 'src/pages/error/403';
import CreateHotSearch from './Create';
import EditHotSearch from './Edit';
import './init';

const ListFilter = (props: any) => (
  <Filter {...(props || {})}>
    <SelectInput
      source="board"
      label="Board"
      choices={[
        { id: 'ALL', name: 'ALL' },
        { id: 'CONTRACT', name: 'CONTRACT' },
        { id: 'MEME', name: 'MEME' },
        { id: 'USTOCK', name: 'USTOCK' },
      ]}
      // defaultValue="CONTRACT"
      alwaysOn
    />
  </Filter>
);

const View = () => {
  const [popup, setPopup] = useState<ReactElement>();
  const t = useTranslate();
  const formatWithToISOString = (date: Date) => {
    // 步骤1：修正时区（东八区）
    const offset = date.getTimezoneOffset() * 60000; // 东八区为-480分钟 → -28800000毫秒
    const localDate = new Date(date.getTime() - offset);

    // 步骤2：调用toISOString() + 去掉Z后缀 + 裁剪毫秒
    const isoStr = localDate.toISOString(); // 此时是东八区的ISO串：2025-12-18T16:14:00.000Z
    const formatted = isoStr.replace('.000Z', ''); // 去掉毫秒和Z → 2025-12-18T16:14:00

    return formatted;
  };
  return (
    <PermissionGuard resource="hotSearching" action="read" fallback={<ErrorPage403 />}>
      <DashboardContent>
        <CustomBreadcrumbs
          heading={t('module.hot-search.title')}
          links={[
            { name: t('module.hot-search.popularSearchCfg'), href: `/${Resources.hotSearch}` },
            { name: t('resource.list') },
          ]}
          action={
            <PermissionGuard resource="hotSearching" action="create" fallback={<></>}>
              <CreateButton
                variant="contained"
                size="medium"
                onClick={(e) => {
                  e.preventDefault();
                  setPopup(<CreateHotSearch onClose={() => setPopup(undefined)} />);
                }}
              />
            </PermissionGuard>
          }
        />

        <Card sx={{ mt: 3, pb: 2 }}>
          <List
            actions={false}
            empty={false}
            filters={<ListFilter />}
            perPage={10}
            exporter={false}
            resource={Resources.hotSearch}
          >
            <Box sx={{ overflow: 'auto' }}>
              <Datagrid
                rowClick={false}
                sx={{
                  '& .RaDatagrid-table': {
                    tableLayout: 'fixed',
                    minWidth: 1400,
                    width: '100%',
                  },
                  '& .RaDatagrid-thead th, & .RaDatagrid-tbody td': {
                    whiteSpace: 'nowrap',
                    padding: '8px 12px',
                    verticalAlign: 'middle',
                  },
                  /* 勾选框 */
                  '& .RaDatagrid-thead th:nth-of-type(1), & .RaDatagrid-tbody td:nth-of-type(1)': {
                    width: 40,
                    minWidth: 40,
                  },
                  /* board */
                  '& .RaDatagrid-thead th:nth-of-type(2), & .RaDatagrid-tbody td:nth-of-type(2)': {
                    width: 80,
                    minWidth: 80,
                  },
                  /* mode */
                  '& .RaDatagrid-thead th:nth-of-type(3), & .RaDatagrid-tbody td:nth-of-type(3)': {
                    width: 120,
                    minWidth: 120,
                  },
                  /* symbol */
                  '& .RaDatagrid-thead th:nth-of-type(4), & .RaDatagrid-tbody td:nth-of-type(4)': {
                    width: 80,
                    minWidth: 80,
                  },
                  /* chainId */
                  '& .RaDatagrid-thead th:nth-of-type(5), & .RaDatagrid-tbody td:nth-of-type(5)': {
                    width: 80,
                    minWidth: 80,
                  },
                  /* token contract */
                  '& .RaDatagrid-thead th:nth-of-type(6), & .RaDatagrid-tbody td:nth-of-type(6)': {
                    width: 400,
                    minWidth: 400,
                  },
                  /* token name */
                  '& .RaDatagrid-thead th:nth-of-type(7), & .RaDatagrid-tbody td:nth-of-type(7)': {
                    width: 120,
                    minWidth: 120,
                  },
                  /* show Text */
                  '& .RaDatagrid-thead th:nth-of-type(8), & .RaDatagrid-tbody td:nth-of-type(8)': {
                    width: 220,
                    minWidth: 220,
                  },
                  /* showFlame */
                  '& .RaDatagrid-thead th:nth-of-type(9), & .RaDatagrid-tbody td:nth-of-type(9)': {
                    width: 100,
                    minWidth: 100,
                  },
                  /* status */
                  '& .RaDatagrid-thead th:nth-of-type(10), & .RaDatagrid-tbody td:nth-of-type(10)':
                    {
                      width: 100,
                      minWidth: 100,
                    },
                  /* updateTime */
                  '& .RaDatagrid-thead th:nth-of-type(11), & .RaDatagrid-tbody td:nth-of-type(11)':
                    {
                      width: 200,
                      minWidth: 200,
                    },
                  /* operator */
                  '& .RaDatagrid-thead th:nth-of-type(12), & .RaDatagrid-tbody td:nth-of-type(12)':
                    {
                      width: 100,
                      minWidth: 100,
                    },
                  /* Edit */
                  '& .RaDatagrid-thead th:nth-of-type(13), & .RaDatagrid-tbody td:nth-of-type(13)':
                    {
                      width: 100,
                      minWidth: 100,
                    },
                  '.RaBulkActionsToolbar-toolbar': {
                    position: 'relative !important',
                    transform: 'none !important',
                  },
                }}
              >
                <FunctionField
                  label={t('module.hot-search.board')}
                  render={(record: any) => {
                    const boardMap: Record<string, string> = {
                      CONTRACT: 'CONTRACT',
                      MEME: 'MEME',
                      USTOCK: 'USTOCK',
                    };
                    return boardMap[record.board] || record.board;
                  }}
                  sortable={false}
                />
                <FunctionField
                  label={t('module.hot-search.mode')}
                  render={(record: any) => {
                    const modeMap: Record<string, string> = {
                      SYSTEM_AUTO: 'SYSTEM_AUTO',
                      DEFAULT_TEXT: 'DEFAULT_TEXT',
                      CUSTOM: 'CUSTOM',
                    };
                    return modeMap[record.mode] || record.mode;
                  }}
                  sortable={false}
                />
                <TextField source="symbol" label={t('module.hot-search.symbol')} sortable={false} />
                <TextField source="chainId" label={t('module.hot-search.chainId')} sortable={false} />
                <FunctionField
                  label={t('module.hot-search.tokenContract')}
                  render={(record: any) => (
                    <Box sx={{ maxWidth: 400, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                      {record.tokenContract || '-'}
                    </Box>
                  )}
                  sortable={false}
                />
                <TextField source="tokenName" label={t('module.hot-search.tokenName')} sortable={false} />
                <TextField source="displayText" label={t('module.hot-search.showText')} sortable={false} />
                <FunctionField
                  label={t('module.hot-search.showFlames')}
                  render={(record: any) => (
                    <Chip
                      label={record.showFlame === true ? 'YES' : 'NO'}
                      color={record.showFlame === true ? 'success' : 'default'}
                      size="small"
                    />
                  )}
                  sortable={false}
                />
                <FunctionField
                  label={t('module.hot-search.status')}
                  render={(record: any) => (
                    <Chip
                      label={record.status === 'ACTIVE' ? 'ACTIVE' : 'INACTIVE'}
                      color={record.status === 'ACTIVE' ? 'success' : 'error'}
                      size="small"
                    />
                  )}
                  sortable={false}
                />
                <FunctionField
                  label={t('module.hot-search.updateTime')}
                  render={(record: any) => {
                    const ts = Number(record?.updatedAt);
                    if (Number.isNaN(ts)) return '-';
                    return formatWithToISOString(new Date(ts));
                  }}
                  sortable={false}
                />
                <TextField source="operator" label={t('module.hot-search.operator')} sortable={false} />
                <FunctionField
                  label={t('module.hot-search.operating')}
                  render={(record: any) => (
                    <Stack direction="row" spacing={2}>
                      <PermissionGuard resource="hotSearching" action="update" fallback={<></>}>
                        <EditButton
                          onClick={(e) => {
                            e.preventDefault();
                            setPopup(
                              <EditHotSearch id={record.id} onClose={() => setPopup(undefined)} />
                            );
                          }}
                        />
                      </PermissionGuard>
                    </Stack>
                  )}
                />
              </Datagrid>
            </Box>
          </List>
        </Card>
        <Dialog open={Boolean(popup)} onClose={() => setPopup(undefined)} maxWidth="md" fullWidth>
          {popup}
        </Dialog>
      </DashboardContent>
    </PermissionGuard>
  );
};

export default View;
